// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"46d22580","809":"ecb47805"}[chunkId] + ".chunk.js";
};